<article #canvasRefComponent>
  <app-loader-wrapper [loading]="loadingDrawing">
    <div class="canvas-wrapper" [appResizeObserver]="canvasRefComponent" (resized)="canvasResized($event.contentRect.width, $event.contentRect.height)">
      <canvas id="warehouseLayout" #canvas></canvas>
      <a mat-button id="navigateToWarehouseBtn" color="primary" class="icon-btn-large" [routerLink]="this.routerLink">
        <mat-icon>zoom_in</mat-icon>
      </a>
    </div>
  </app-loader-wrapper>
</article>
